import {Driver, Vehicle} from 'types';
// import RouteIcon from '../../icons/route';
// import TimeIcon from '../../icons/time';
// import Typography from 'components/Typography';
import styles from './WorkerSelect.module.scss';
import {get} from 'lodash';
import classNames from 'classnames';
import {Route} from 'pages/DeliveryPlanner/useDeliveryPlanner';
// import {kmToMiles} from 'helpers/kmToMiles';
// import IconTeams from 'components/Sidebar/MenuIcon/IconTeams';
// import IconUser from '../../icons/user';
import Individual from './Individual';
import Team from './Team';

type Props = {
  route: Route;
  teams: Vehicle[];
  workers: Driver[];
  selectedWorker: Driver | Vehicle;
  onSelectWorker: (val: Vehicle | Driver) => void;
  // onTeamPressed: () => void;
};

function WorkerSelect({
  teams,
  workers,
  route,
  selectedWorker,
  onSelectWorker,
}: // onTeamPressed,
Props) {
  // const total_time = route?.total_time
  //   ? `${Math.floor(route.total_time / 60)}h ${route.total_time % 60}m`
  //   : '0:00';
  const isIndividual = !!selectedWorker && 'driver_id' in selectedWorker;
  const assignedWorkerOrTeam = isIndividual
    ? (selectedWorker as Driver)
    : (selectedWorker as Vehicle);
  const selectedId = isIndividual
    ? selectedWorker?.driver_id
    : selectedWorker?.id;
  // route.total_distance is in kilometers.  (1 km ≈ 0.621371 mi)
  // const total_distance = kmToMiles(route.total_distance);
  return (
    <div className={styles.teams}>
      <div className={classNames(styles.selectContainer, 'assign-team')}>
        <Individual
          selectedId={isIndividual ? selectedId : undefined}
          value={
            isIndividual
              ? {
                  label:
                    get(assignedWorkerOrTeam, 'first_name', '') +
                    ' ' +
                    get(assignedWorkerOrTeam, 'last_name', ''),
                  //@ts-ignore
                  value: assignedWorkerOrTeam?.driver_id,
                }
              : null
          }
          options={
            workers?.map((item) => ({
              ...item,
              label: item?.name,
              value: item?.driver_id,
            })) as any
          }
          onChange={onSelectWorker}
        />
        <Team
          selectedId={!isIndividual ? selectedId : undefined}
          value={
            !isIndividual && assignedWorkerOrTeam
              ? {
                  label: assignedWorkerOrTeam?.name,
                  value: assignedWorkerOrTeam?.id,
                }
              : null
          }
          options={
            teams?.map((item) => ({
              ...item,
              label: item.name,
              value: item?.id,
            })) as any
          }
          onChange={onSelectWorker}
        />
      </div>

      {/* {!!assignedWorkerOrTeam && (
        <div className={styles.teamItem}>
          <div className={styles.teamItemHeader}>
            <div
              style={{
                backgroundColor: isIndividual
                  ? '#4285f4'
                  : (assignedWorkerOrTeam as Vehicle)?.color || '#4285f4',
              }}
              onClick={onTeamPressed}
              className={styles.teamItemHeaderIcon}
            >
              {isIndividual ? (
                <IconUser color="#fff" />
              ) : (
                <IconTeams color="#fff" />
              )}
            </div>
            <div className={styles.teamItemHeaderText}>
              <Typography className={styles.teamItemHeaderTextName}>
                {isIndividual
                  ? (assignedWorkerOrTeam as Driver)?.first_name +
                    ' ' +
                    (assignedWorkerOrTeam as Driver)?.last_name
                  : assignedWorkerOrTeam?.name}
              </Typography>
            </div>
          </div>
          <div className={styles.teamItemStats}>
            <Typography
              variant="p"
              className={classNames(styles.teamItemStatText, styles.colored)}
            >
              {route.deliveries.length} stops
            </Typography>
            <div className={styles.teamItemStatsItem}>
              <TimeIcon size={15} />
              <Typography
                variant="p"
                className={classNames(styles.teamItemStatText, styles.colored)}
              >
                {total_time}
              </Typography>
            </div>
            <div className={styles.teamItemStatsItem}>
              <RouteIcon size={16} />
              <Typography
                variant="p"
                className={classNames(styles.teamItemStatText, styles.colored)}
              >
                {total_distance} mi
              </Typography>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default WorkerSelect;
